import Router from 'next/router';

export { useRouter, withRouter } from 'next/router';
export { getQueryString, removeQueryParams, getCurrentPath } from './nextRouter';

export default Router;
